export default {
  showModalPatchNotes: false,
  patchNotes: [],
};
